import {
  AvatarStack,
  Box,
  CardInfo,
  StatusLabel,
  Text,
} from '@factorialco/deprecated-design-system'
import { ProjectManagementMutationsCreateProjectmanagementProjectTaskArgs as ProjectTaskArgs } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { statusOption } from 'modules/tasks/lib/status'

import { Description } from './Description'
import { Files } from './Files'

type Avatar = React.ComponentProps<typeof AvatarStack>['avatars'][number]

interface Props {
  task: ProjectTaskArgs
  subprojectName: string
  asignees: Avatar[]
  files: File[]
}

export const Preview = ({ task, subprojectName, asignees, files }: Props) => {
  const itemsCount = 3
  const leftover = asignees.length - itemsCount
  const selectedStatus = statusOption(task.status)
  return (
    <>
      <CardInfo>
        <Box minHeight="s400">
          <Text.Header1 overflowWrap>{task.name}</Text.Header1>
          <Box flexDirection="row" paddingY="s24" justifyContent="spaceBetween">
            <Box gap="s4">
              <Text.Normal>{i18n.t('project_management.tasks.form.labels.status')}</Text.Normal>
              <StatusLabel type={selectedStatus?.statusType ?? 'neutral'}>
                {selectedStatus?.title ?? i18n.t('tasks.status.todo')}
              </StatusLabel>
            </Box>
            <Box gap="s4" maxWidth="s200">
              <Text.Normal>{i18n.t('project_management.tasks.form.labels.subproject')}</Text.Normal>
              <Text size="300" weight="medium" color="grey1000">
                {subprojectName}
              </Text>
            </Box>
            <Box gap="s4" minWidth="s140">
              <Text.Normal>{i18n.t('project_management.tasks.form.labels.assignees')}</Text.Normal>
              <AvatarStack
                size="s32"
                leftover={leftover}
                overlap="s8"
                backgroundColor="champagne1000"
                textSize="200"
                textColor="grey000White"
                avatars={asignees.slice(0, itemsCount)}
              />
            </Box>
          </Box>
          <Description content={task.content} />
          <Files files={files} />
        </Box>
      </CardInfo>
    </>
  )
}
